import { usePathname, useSearchParams } from 'next/navigation'

export default function usePathnameWithSearch() {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	return searchParams.size > 0 ? `${pathname}?${searchParams.toString()}` : pathname
}
